// RevenueCat.ts
import { Capacitor } from '@capacitor/core';

import {
  Purchases as PurchasesWeb,
  LogLevel as WebLogLevel,
} from '@revenuecat/purchases-js';

import {
  Purchases as PurchasesNative,
  LOG_LEVEL as NativeLogLevel,
} from '@revenuecat/purchases-capacitor';

let configured = false;
let currentUserId: string | null = null;

function isNativePlatform() {
  const platform = Capacitor.getPlatform();
  return platform === 'android' || platform === 'ios';
}

export function isRevenueCatConfigured() {
  return configured;
}

export function getCurrentRevenueCatUserId() {
  return currentUserId;
}

export async function configureRevenueCat(appUserId: string): Promise<void> {
  if (!appUserId) return;

  const platform = Capacitor.getPlatform();

  // ===== NATIVE: Android / iOS =====
  if (platform === 'android' || platform === 'ios') {
    const apiKey =
      platform === 'android'
        ? (import.meta.env.VITE_RC_ANDROID_API_KEY as string)
        : (import.meta.env.VITE_RC_IOS_API_KEY as string);

    await PurchasesNative.setLogLevel({ level: NativeLogLevel.DEBUG });

    let nativeAlreadyConfigured = false;

    try {
      const result = await PurchasesNative.isConfigured();
      nativeAlreadyConfigured = !!result.isConfigured;
    } catch (e) {
      nativeAlreadyConfigured = configured;
    }

    if (!nativeAlreadyConfigured) {
      await PurchasesNative.configure({
        apiKey,
        appUserID: appUserId,
      });

      configured = true;
      currentUserId = appUserId;
      return;
    }

    // Native SDK is already configured. Make sure it is using the desired user.
    //if (currentUserId !== appUserId) {
      await PurchasesNative.logIn({ appUserID: appUserId });
      //currentUserId = appUserId;
    //}

    configured = true;
    return;
  }

  // ===== WEB =====
  const apiKey = import.meta.env.VITE_RC_WEB_PUBLIC_KEY as string;

  PurchasesWeb.setLogLevel(WebLogLevel.Debug);

  if (!configured) {
    PurchasesWeb.configure({
      apiKey,
      appUserId,
    });

    configured = true;
    currentUserId = appUserId;
    return;
  }

  if (currentUserId !== appUserId) {
    await PurchasesWeb.getSharedInstance().changeUser(appUserId);
    currentUserId = appUserId;
  }
}